<w-block-ui [blocked]="blocked" [title]="'processing' | translate" [text]="'please_wait' | translate"></w-block-ui>

<form [formGroup]="requestForm">

    <w-page-header [title]="'noticeOfUnauthorizedUse.pageTitle' | translate" [disableUppercase]="true"
        [showPortfolio]="false"></w-page-header>

    <w-step>
        <p facet-step-info [innerHTML]="'noticeOfUnauthorizedUse.pageDesc' | translate"></p>
    </w-step>

    <!-- Requesting Party + Responding Party -->
    <w-edit-panel>
        <w-section>
            <w-slot>
                <w-input-text label="{{ 'requestingPartyName' | translate }}" [labelOnTop]="true" [required]="true"
                    formControlName="nameComplainant">
                    @if (submitted && f.nameComplainant.errors?.required) {
                    <f-facet name="error">{{ 'validationWarning' | translate }}</f-facet>
                    }
                    @if (submitted && f.nameComplainant.errors?.maxlength) {
                    <f-facet name="error">{{ 'textLengthWarning' | translate: { value: '255' } }}</f-facet>
                    }
                </w-input-text>

                <w-input-text label="{{ 'address' | translate }}" [labelOnTop]="true" formControlName="addressComplainant">
                    @if (submitted && f.addressComplainant.errors?.maxlength) {
                    <f-facet name="error">{{ 'textLengthWarning' | translate: { value: '255' } }}</f-facet>
                    }
                </w-input-text>

                <w-select-one label="{{ 'country' | translate }}" [labelOnTop]="true" [required]="true"
                    formControlName="countryComplainantCode" [options]="countryOptions">
                    @if (submitted && f.countryComplainantCode.errors?.required) {
                    <f-facet name="error">{{ 'validationWarning' | translate }}</f-facet>
                    }
                </w-select-one>

                <w-input-text label="{{ 'tel' | translate }}" [labelOnTop]="true" formControlName="telephoneComplainant">
                    @if (submitted && f.telephoneComplainant.errors?.maxlength) {
                    <f-facet name="error">{{ 'textLengthWarning' | translate: { value: '255' } }}</f-facet>
                    }
                </w-input-text>

                <w-input-text label="{{ 'email' | translate }}" [labelOnTop]="true" [required]="true"
                    formControlName="emailComplainant" [type]="'email'">
                    @if (submitted && f.emailComplainant.errors?.required) {
                    <f-facet name="error">{{ 'validationWarning' | translate }}</f-facet>
                    }
                    @if (f.emailComplainant.errors?.email) {
                    <f-facet name="error">{{ 'validationEmail' | translate }}</f-facet>
                    }
                    @if (submitted && f.emailComplainant.errors?.maxlength) {
                    <f-facet name="error">{{ 'textLengthWarning' | translate: { value: '255' } }}</f-facet>
                    }
                </w-input-text>

                <w-input-text label="{{ 'noticeOfUnauthorizedUse.representedBy' | translate }}" [labelOnTop]="true"
                    formControlName="representedByComplainant"></w-input-text>

                <w-input-text label="{{ 'noticeOfUnauthorizedUse.representativeAddress' | translate }}"
                    [labelOnTop]="true" formControlName="addressRepresentativeComplainant"></w-input-text>

                <w-select-one label="{{ 'noticeOfUnauthorizedUse.representativeCountry' | translate }}"
                    [labelOnTop]="true" formControlName="countryComplainantRepByCode" [options]="countryOptions"></w-select-one>

                <w-input-text label="{{ 'noticeOfUnauthorizedUse.representativeTelephone' | translate }}"
                    [labelOnTop]="true" formControlName="telephoneRepresentativeComplainant"></w-input-text>

                <w-input-text label="{{ 'noticeOfUnauthorizedUse.representativeEmail' | translate }}"
                    [labelOnTop]="true" formControlName="emailRepresentativeComplainant" [type]="'email'">
                    @if (f.emailRepresentativeComplainant.errors?.email) {
                    <f-facet name="error">{{ 'validationEmail' | translate }}</f-facet>
                    }
                </w-input-text>
            </w-slot>

            <w-slot>
                <w-input-text label="{{ 'respondingByName' | translate }}" [labelOnTop]="true" [required]="true"
                    formControlName="nameRespondent">
                    @if (submitted && f.nameRespondent.errors?.required) {
                    <f-facet name="error">{{ 'validationWarning' | translate }}</f-facet>
                    }
                    @if (submitted && f.nameRespondent.errors?.maxlength) {
                    <f-facet name="error">{{ 'textLengthWarning' | translate: { value: '255' } }}</f-facet>
                    }
                </w-input-text>

                <w-input-text label="{{ 'address' | translate }}" [labelOnTop]="true" formControlName="addressRespondent">
                    @if (submitted && f.addressRespondent.errors?.maxlength) {
                    <f-facet name="error">{{ 'textLengthWarning' | translate: { value: '255' } }}</f-facet>
                    }
                </w-input-text>

                <w-select-one label="{{ 'country' | translate }}" [labelOnTop]="true" [required]="true"
                    formControlName="countryRespondentCode" [options]="countryOptions">
                    @if (submitted && f.countryRespondentCode.errors?.required) {
                    <f-facet name="error">{{ 'validationWarning' | translate }}</f-facet>
                    }
                </w-select-one>

                <w-input-text label="{{ 'tel' | translate }}" [labelOnTop]="true" formControlName="telephoneRespondent">
                    @if (submitted && f.telephoneRespondent.errors?.maxlength) {
                    <f-facet name="error">{{ 'textLengthWarning' | translate: { value: '255' } }}</f-facet>
                    }
                </w-input-text>

                <w-input-text label="{{ 'email' | translate }}" [labelOnTop]="true" 
                    formControlName="emailRespondent" [type]="'email'">
                    @if (f.emailRespondent.errors?.email) {
                    <f-facet name="error">{{ 'validationEmail' | translate }}</f-facet>
                    }
                    @if (submitted && f.emailRespondent.errors?.maxlength) {
                    <f-facet name="error">{{ 'textLengthWarning' | translate: { value: '255' } }}</f-facet>
                    }
                </w-input-text>

                <w-input-text label="{{ 'noticeOfUnauthorizedUse.representedBy' | translate }}" [labelOnTop]="true"
                    formControlName="representedByRespondent"></w-input-text>

                <w-input-text label="{{ 'noticeOfUnauthorizedUse.representativeAddress' | translate }}"
                    [labelOnTop]="true" formControlName="addressRepresentativeRespondent"></w-input-text>

                <w-select-one label="{{ 'noticeOfUnauthorizedUse.representativeCountry' | translate }}"
                    [labelOnTop]="true" formControlName="countryRespondentRepByCode" [options]="countryOptions"></w-select-one>

                <w-input-text label="{{ 'noticeOfUnauthorizedUse.representativeTelephone' | translate }}"
                    [labelOnTop]="true" formControlName="telephoneRepresentativeRespondent"></w-input-text>

                <w-input-text label="{{ 'noticeOfUnauthorizedUse.representativeEmail' | translate }}"
                    [labelOnTop]="true" formControlName="emailRepresentativeRespondent" [type]="'email'">
                    @if (f.emailRepresentativeRespondent.errors?.email) {
                    <f-facet name="error">{{ 'validationEmail' | translate }}</f-facet>
                    }
                </w-input-text>
            </w-slot>
        </w-section>
    </w-edit-panel>
</form>

<app-additional-party #additionalPartyForm [(ngModel)]="additionalParties" [dispCountry]="true"></app-additional-party>
<br><br>

<form [formGroup]="requestForm">
    <!-- Notice body -->
    <w-edit-panel>
        <w-section>
            <f-facet name="header">{{ 'noticeOfUnauthorizedUse.noticeBody' | translate }}</f-facet>
            <w-slot>
                <w-input-textarea label="{{ 'noticeOfUnauthorizedUse.disputeDescription' | translate }}" [required]="true"
                    formControlName="disputeDescription">
                    @if (submitted && f.disputeDescription.errors?.required) {
                    <f-facet name="error">{{ 'validationWarning' | translate }}</f-facet>
                    }
                    @if (submitted && f.disputeDescription.errors?.maxlength) {
                    <f-facet name="error">{{ 'textLengthWarning' | translate: { value: '18000' } }}</f-facet>
                    }
                </w-input-textarea>
            </w-slot>
        </w-section>

        <w-section>
            <f-facet name="header">{{ 'noticeOfUnauthorizedUse.requestedAction' | translate }}</f-facet>
            <w-slot>
                <w-input-textarea label="{{ 'noticeOfUnauthorizedUse.requestedActionDesc' | translate }}"
                    [required]="true" formControlName="requestedAction">
                    @if (submitted && f.requestedAction.errors?.required) {
                    <f-facet name="error">{{ 'validationWarning' | translate }}</f-facet>
                    }
                    @if (submitted && f.requestedAction.errors?.maxlength) {
                    <f-facet name="error">{{ 'textLengthWarning' | translate: { value: '18000' } }}</f-facet>
                    }
                </w-input-textarea>
            </w-slot>
        </w-section>

         <w-section>
            <w-slot>
              <w-input-checkbox-one label="{{ 'noticeOfUnauthorizedUse.privacyConsent' | translate}}"
                [(ngModel)]="privacyConsent" [ngModelOptions]="{standalone: true}" (ngModelChange)="onPrivacyConsentChange()">
                @if (submitted && privacyConsentInvalid) {
                  <f-facet id="privacyConsentRequired" name="error">{{'validationWarning' | translate }}</f-facet>
                }
              </w-input-checkbox-one>
            </w-slot>
          </w-section>

    </w-edit-panel>

    

    <f-facet name="step-info">
        <w-page-header [disableUppercase]="true" [showPortfolio]="false">
            <f-facet name="actions">
                <button id="generateNotice" w-button [isDefault]="true" type="button" (click)="generateNotice()">
                    {{ 'noticeOfUnauthorizedUse.generateNotice' | translate }}
                </button>
            </f-facet>
        </w-page-header>
        <br><br>
    </f-facet>


</form>

<!-- Preview dialog -->
@if (previewOpen) {
<div class="notice-modal-overlay" role="dialog" aria-modal="true">
    <div class="notice-modal">
        <div class="notice-modal__header">
            <h2>{{ 'noticeOfUnauthorizedUse.generatedNotice' | translate }}</h2>
            <button type="button" w-button size="small" [isSecondary]="true" [label]="'close' | translate"
                (click)="closePreview()"></button>
        </div>
        <div class="notice-modal__body">
            <pre class="notice-output">{{ previewText }}</pre>
        </div>
        <div class="notice-modal__actions">
            <button type="button" w-button [isSecondary]="true"
                [label]="'noticeOfUnauthorizedUse.copyClipboard' | translate" (click)="copyToClipboard()"></button>
            <button type="button" w-button [isDefault]="true"
                [label]="'noticeOfUnauthorizedUse.downloadWord' | translate" (click)="downloadDocx()"></button>
        </div>
    </div>
</div>
}